import { render, staticRenderFns } from "./AdminPlatform.vue?vue&type=template&id=36fbb372"
import script from "./AdminPlatform.vue?vue&type=script&lang=js"
export * from "./AdminPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports